/*
  Koszyk: kod rabatowy i zgoda na regulamin.

  Zgoda musi blokowac KAZDA droge do kasy, nie tylko zwykly przycisk:
  - submit formularza koszyka (takze klawiszem Enter),
  - przyciski ekspresowe Shopify (Shop Pay, Apple Pay, Google Pay), ktore
    siedza w osobnym kontenerze i nie przechodza przez submit formularza.
  Blokada jest po stronie przegladarki - to wymog formalny sklepu, nie
  zabezpieczenie techniczne.
*/
(function () {
  'use strict';

  function obsluz(korzen) {
    if (korzen.dataset.ciroaGotowe) return;
    korzen.dataset.ciroaGotowe = '1';

    var zgoda = korzen.querySelector('[data-zgoda]');
    var bladZgody = korzen.querySelector('[data-blad-zgody]');

    /* Strona koszyka renderuje DWA komplety zgody: swoj wlasny i ten z szuflady,
       bo szuflada siedzi w layoucie na kazdej stronie. Kazdy komplet zaklada
       blokade na calym dokumencie, wiec bez rozroznienia kontekstu zgoda
       z szuflady blokowala zakup ze strony koszyka - a jej komunikat
       wyswietlal sie w niewidocznej szufladzie. Stad `wSzufladzie`. */
    var wSzufladzie = !!korzen.closest('cart-drawer');
    var formularz =
      korzen.closest('form') ||
      document.querySelector(wSzufladzie ? '#CartDrawer-Form' : 'form#cart') ||
      document.querySelector('form[action*="/cart"]');

    /* ---------- kod rabatowy ---------- */
    var pole = korzen.querySelector('[data-pole-kodu]');
    var przycisk = korzen.querySelector('[data-zastosuj-kod]');
    var bladKodu = korzen.querySelector('[data-blad-kodu]');

    function zastosuj() {
      var kod = (pole.value || '').trim().toUpperCase().replace(/\s+/g, '');
      if (!kod) {
        bladKodu.textContent = 'Wpisz kod rabatowy.';
        pole.focus();
        return;
      }
      bladKodu.textContent = 'Sprawdzamy kod...';
      /* Shopify sam weryfikuje kod pod tym adresem i wraca do koszyka. */
      window.location.href = '/discount/' + encodeURIComponent(kod) + '?redirect=/cart';
    }
    if (przycisk) przycisk.addEventListener('click', zastosuj);
    if (pole) pole.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); zastosuj(); }
    });

    /* ---------- zakup na firme ---------- */
    var poleNip = korzen.querySelector('[data-pole-nip]');
    var bladNip = korzen.querySelector('[data-blad-nip]');

    /* Suma kontrolna NIP-u: wagi 6,5,7,2,3,4,5,6,7 modulo 11.
       Sprawdzamy po stronie przegladarki, zeby literowka nie wyszla
       dopiero przy wystawianiu faktury. */
    function nipPoprawny(wartosc) {
      var c = (wartosc || '').replace(/[^0-9]/g, '');
      if (c.length !== 10) return false;
      var wagi = [6, 5, 7, 2, 3, 4, 5, 6, 7];
      var suma = 0;
      for (var i = 0; i < 9; i++) suma += wagi[i] * Number(c[i]);
      var reszta = suma % 11;
      return reszta !== 10 && reszta === Number(c[9]);
    }

    if (poleNip) {
      poleNip.addEventListener('blur', function () {
        var w = poleNip.value.trim();
        if (!w) { bladNip.hidden = true; poleNip.removeAttribute('aria-invalid'); return; }
        var ok = nipPoprawny(w);
        bladNip.hidden = ok;
        bladNip.textContent = ok ? '' : 'Ten NIP wygląda na niepoprawny - sprawdź cyfry.';
        poleNip.setAttribute('aria-invalid', ok ? 'false' : 'true');
      });
      poleNip.addEventListener('input', function () {
        if (!bladNip.hidden) { bladNip.hidden = true; poleNip.removeAttribute('aria-invalid'); }
      });
    }

    /* ---------- zgoda na regulamin ---------- */
    function przyciskiEkspresowe() {
      var kontener = document.querySelector('.cart__dynamic-checkout-buttons, .additional-checkout-buttons');
      return kontener;
    }

    /* Czerwony komunikat pokazujemy dopiero, gdy ktos naprawde probowal przejsc
       do kasy. Wczesniej wisial od wejscia na koszyk i czytal sie jak blad
       jeszcze zanim klientka cokolwiek zrobila. */
    var bylaProba = false;

    function odswiez() {
      var ok = !zgoda || zgoda.checked;
      bladZgody.hidden = ok || !bylaProba;
      var ekspres = przyciskiEkspresowe();
      if (ekspres) {
        ekspres.style.pointerEvents = ok ? '' : 'none';
        ekspres.style.opacity = ok ? '' : '0.45';
        ekspres.setAttribute('aria-disabled', ok ? 'false' : 'true');
      }
      korzen.querySelectorAll('[data-zgoda]').forEach(function (p) {
        p.setAttribute('aria-invalid', ok ? 'false' : 'true');
        var etykieta = p.closest('.ciroa-koszyk__zgoda');
        if (etykieta) etykieta.classList.toggle('ciroa-koszyk__zgoda--blad', !ok && bylaProba);
      });
    }

    function zablokuj(zdarzenie) {
      if (zgoda && !zgoda.checked) {
        zdarzenie.preventDefault();
        zdarzenie.stopPropagation();
        bylaProba = true;
        odswiez();
        zgoda.focus();
        return false;
      }
    }

    if (zgoda) {
      zgoda.addEventListener('change', odswiez);
      odswiez();
      if (formularz) {
        formularz.addEventListener('submit', function (e) {
          /* submit wywolany przyciskiem "Realizuj zakup" albo klawiszem */
          var kto = e.submitter;
          if (!kto || kto.name === 'checkout') zablokuj(e);
        }, true);
      }
      /* Przechwytujemy takze klikniecia w przyciski ekspresowe. Listener siedzi
         na dokumencie, wiec musi sam sprawdzic, czy klikniety przycisk nalezy do
         tego samego kontekstu co ta zgoda. */
      document.addEventListener('click', function (e) {
        var cel = e.target.closest('.cart__dynamic-checkout-buttons, .additional-checkout-buttons, [name="checkout"]');
        if (!cel) return;
        if (!!cel.closest('cart-drawer') !== wSzufladzie) return;
        zablokuj(e);
      }, true);
    }
  }

  function start() {
    document.querySelectorAll('[data-ciroa-koszyk]').forEach(obsluz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  /* Szuflada koszyka przerysowuje sie po kazdej zmianie ilosci. */
  document.addEventListener('cart:refresh', start);
  new MutationObserver(start).observe(document.documentElement, { childList: true, subtree: true });
})();
